import React, { useRef, useEffect, useState, useCallback } from "react";
import { FaSearchengin } from "react-icons/fa";
import { FaRegUserCircle } from "react-icons/fa";
import Marquee from "react-fast-marquee";
import "./ticketrise.css";
import Chatbox from "../components/Chat&assign/Chatbox";
import Ticket from "../components/ticketrise/Ticket";
import { motion } from "framer-motion";
import { toast } from "react-toastify";

function Ticketrise() {
  const [searchedTicket, setSearchedTicket] = useState("");
  const [popupvalue, setPopupvalue] = useState("");

  const approval = searchedTicket.approval_actions || {};

  const approvals = [
    approval.A1
      ? approval.A1.status === "Approved"
        ? "Manager Approved"
        : "Manager Pending"
      : null,
    approval.A2
      ? approval.A2.status === "Approved"
        ? "Business Head Approved"
        : "Business Head Pending"
      : null,
  ].filter(Boolean);

  const normalFlow = [
    "Un Assigned",
    "Assigned",
    "Opened",
    "Hold",
    "Closed / Dismissed",
  ];

  const statusFlow = [
    "Approval Pending",
    "Un Assigned",
    "Assigned",
    "Opened",
    "Hold",
    "Closed",
    "Dismissed",
  ];

  // const getStatusIndex = (status) => {
  //   return statusFlow.indexOf(status);
  // };

  const [ticketNumber, setTicketNumber] = useState("");

  const userDetails = JSON.parse(localStorage.getItem("userdetails"));
  const [oldtickets, setoldtickets] = useState([]);

  const handleoldtickets = useCallback(async () => {
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/getoldtickets.php`;
    const formData = new FormData();
    try {
      formData.append("user_id", userDetails?.id);
      formData.append("subs", userDetails?.sub);

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });
      const result = await response.json();
      if (result.message === "Records fetched successfully") {
        setoldtickets(result.data);
      }
    } catch (error) {
      console.error("Error fetching tickets:", error);
    }
  }, [userDetails]);

  useEffect(() => {
    handleoldtickets();
  }, []);

  // const handleticket = async (event) => {
  //   event.preventDefault();
  //   setIsLoading(true); // show loader

  //   const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/ticket.php`;
  //   const formData = new FormData();
  //   formData.append("subs", userDetails?.sub);

  //   formData.append("user_id", userDetails?.id);
  //   formData.append("name", userDetails?.username);
  //   formData.append(
  //     "contact_number",
  //     ticketform?.contact || userDetails?.phone
  //   );
  //   formData.append("e_des", ticketform?.description);
  //   formData.append("files", ticketform.file);
  //   formData.append("title", ticketform.title);
  //   formData.append("status", "Un Assigned");

  //   try {
  //     const response = await fetch(apiUrl, {
  //       method: "POST",
  //       body: formData,
  //     });

  //     const data = await response.json();

  //     if (response.ok) {
  //       handleoldtickets();
  //       setticketform({
  //         name: "",
  //         contact: "",
  //         description: "",
  //         file: null,
  //         title: "",
  //       });

  //       if (fileInputRef.current) {
  //         fileInputRef.current.value = "";
  //       }

  //       toast.success(
  //         `Ticket Created Successfully!\nTicket Number: ${data.ticket_number}`
  //       );
  //     } else {
  //       alert(`Error: ${data.message || "An unexpected error occurred."}`);
  //     }
  //   } catch (error) {
  //     console.error("Error during ticket submission:", error);
  //     alert(`Error: ${error.message}`);
  //   } finally {
  //     setIsLoading(false); // hide loader
  //   }
  // };

  const handleTicketTrack = async () => {
    if (!ticketNumber) {
      toast.error("Enter a ticket number before searching.");
    } else {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/tickettrack.php`;
      const formData = new FormData();

      formData.append("user_id", userDetails?.id);
      formData.append("ticketnumber", ticketNumber.trim());

      try {
        const response = await fetch(apiUrl, {
          method: "POST",
          body: formData,
        });

        const result = await response.json();

        if (
          response.ok &&
          result.message === "Ticketnumber tracked successfully"
        ) {
          if (Array.isArray(result.data) && result.data.length > 0) {
            setSearchedTicket(result.data[0]);
            setTicketNumber("");
            setPopupvalue("ticketFound");
          } else {
            alert("Error: No ticket data found.");
            setSearchedTicket(null);
          }
        } else {
          toast.error("Ticket not found");
        }
      } catch (error) {
        console.error("Error tracking tickets:", error);
        alert("Error connecting to server.");
        setSearchedTicket(null);
      }
    }
  };

  const getStatusIndex = (currentStatus, flow) => {
    // Map Closed/Dismissed to the merged label
    if (currentStatus === "Closed" || currentStatus === "Dismissed") {
      currentStatus = "Closed / Dismissed";
    }
    return flow.indexOf(currentStatus);
  };

  const boxRef = useRef(null);

  const scrollToBox = () => {
    if (boxRef.current) {
      boxRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <motion.div
      className="outermain"
      initial={{ opacity: 0, x: -100 }} // Start off-screen to the left
      animate={{ opacity: 1, x: 0 }} // Animate to the original position
      transition={{ duration: 0.8 }} // Duration of the animation
    >
      <div>
        <h2 className="clientname">{userDetails.clientname}</h2>
      </div>

      {/* Marquee */}
      <div className="tra">
        <div className="Name_tag">
          <div className="profile_icsdfon">
            <FaRegUserCircle />
          </div>
          <h5>Welcome,</h5>
          <span>
            <Marquee speed={40} direction={"right"}>
              {userDetails.username}
            </Marquee>
          </span>
        </div>

        {/* Search Box */}
        <div className="parent-container">
          <h2 className="retick">Track by Your Ticket Id...</h2>
          <div className="search-container">
            <input
              type="text"
              placeholder="Search by Ticket Number"
              value={ticketNumber}
              onChange={(e) => setTicketNumber(e.target.value)}
            />
            <button className="sebtn" onClick={handleTicketTrack}>
              <FaSearchengin />
            </button>
          </div>
        </div>
      </div>

      {/* Tickets Table */}
      <div className="table-container-outer">
        {/* Form for username, email, error title, etc. */}
        <div className="tra1">
          <Ticket handleoldtickets={handleoldtickets} />
        </div>

        <div className="tablecontent1">
          <h2 className="retick">Recent Tickets</h2>
          {/* <div className="table-container1"> */}
          <motion.div
            className="table-container"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <table>
              <thead>
                <tr>
                  <th>Serial No</th>
                  <th>Ticket Number</th>
                  <th>Status</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {oldtickets.length > 0 ? (
                  oldtickets.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.ticket_number}</td>
                      <td>{item.status}</td>
                      <td>{item.created_at}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="tdh">
                      No tickets available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </motion.div>
          {/* </div> */}
        </div>
      </div>

      {/* Ticket Details & Status Flow */}
      {popupvalue === "ticketFound" &&
        Object.keys(searchedTicket).length > 0 && (
          <motion.div
            className="popup-overlay1"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            {/* <div className="popup-content1"> */}
            <div className="ticket-details-wrapper">
              <button
                className="clsbtn"
                onClick={() => {
                  setPopupvalue("");
                  setTicketNumber("");
                }}
              >
                &times;
              </button>

              <div className="ticket-details-container" ref={boxRef}>
                <div className="ticket-details1">
                  <div className="pop1">
                    <div className="Ticket-popup-content">
                      <h2 className="retick">Ticket Details</h2>
                      <div className="ticket-detail">
                        <span className="label1">Ticket Number: </span>
                        <span className="label1">
                          {searchedTicket?.ticketnumber}
                        </span>
                      </div>
                      <div className="ticket-detail">
                        <span className="label1">Contact Number: </span>
                        <span className="label1">
                          {searchedTicket?.contact_number}
                        </span>
                      </div>
                      <div className="ticket-detail">
                        <span className="label1">Error Title: </span>
                        <span className="label1">
                          {searchedTicket?.e_title}
                        </span>
                      </div>
                      <div className="ticket-detail">
                        <span className="label1">Error Description: </span>
                        <span className="label1">{searchedTicket?.e_des}</span>
                      </div>
                      {searchedTicket.files && (
                        <div className="ticket-detail">
                          <span className="label1">Error file: </span>

                          <span className="label1">
                            <a
                              href={`${process.env.REACT_APP_BASEURL}/apis/uploads/${searchedTicket.files}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-500 underline"
                            >
                              {searchedTicket.files}
                            </a>
                          </span>
                        </div>
                      )}
                      {searchedTicket?.remarks?.A1 && (
                        <div className="ticket-detail">
                          <span className="label1">Manager Remarks: </span>
                          <span className="label1">
                            {searchedTicket?.remarks?.A1}
                          </span>
                        </div>
                      )}
                      {searchedTicket?.remarks?.A2 && (
                        <div className="ticket-detail">
                          <span className="label1">
                            Business Head Remarks:{" "}
                          </span>
                          <span className="label1">
                            {searchedTicket?.remarks?.A2}
                          </span>
                        </div>
                      )}
                      <div className="ticket-detail">
                        <span className="label1">Ticket Created Date: </span>
                        <span className="label1">
                          {searchedTicket?.created_at}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="pop2">
                    <div className="status-flow-container">
                      <h2 className="retick">Ticket Status</h2>
                      {statusFlow.map((status, index) => (
                        <div
                          key={status}
                          className={`status-step ${
                            getStatusIndex(searchedTicket.status, statusFlow) >=
                            index
                              ? "completed"
                              : ""
                          }`}
                        >
                          <div className="status-step-background" />
                          <div className="status-step-text">{status}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {searchedTicket && (
                  <motion.div
                    className="raise-chatbox"
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                  >
                    <Chatbox
                      searchedTicketId={searchedTicket?.id}
                      status={searchedTicket?.status}
                      ticketclosed={searchedTicket?.close_time}
                      ticketclosedbyname={searchedTicket?.closedby_name}
                      selectedEmail={userDetails?.email}
                      // ticketassign={ticketassign}
                      // ticketclosed={ticketclosed}
                    />
                    <div className="ticketbtn">
                      <button
                        className="ticket-details-btn"
                        onClick={scrollToBox}
                      >
                        Ticket Details
                      </button>
                    </div>
                  </motion.div>
                )}
              </div>
            </div>
            {/* </div> */}
          </motion.div>
        )}
    </motion.div>
  );
}

export default Ticketrise;
